<template>
  <div class="answers">
    <div v-if="!answerTypeText" class="answers__selection-wrapper">
      <div
        v-for="answer in answers"
        :key="`answer-id-${answerId(answer)}`"
        :class="[
          'answers__selection',
          isSelected(answer) && 'answers__selection--selected',
        ]"
      >
        <label class="answer-checkbox answers__select answers__checkboxes">
          <span class="answer-checkbox__input">
            <input
              v-model="currentSelection"
              :class="[isSelected(answer) && 'answer-checkbox--checked']"
              :type="currentQuestion.widget || 'checkbox'"
              :name="`${answerId(answer)}-checkbox`"
              :value="answerId(answer)"
            />
            <span
              :class="`answer-checkbox__control answer-checkbox__control--${
                currentQuestion.widget || 'checkbox'
              }`"
            >
              <span
                v-if="currentQuestion.widget === 'radio'"
                class="answer-checkbox__radio-dot"
              />
              <CheckboxTick v-else />
            </span>
          </span>
          <div v-html="answerContent(answer)" class="answers__answer"></div>
        </label>
      </div>
    </div>
    <AnswerTextbox
      v-if="answerTypeText"
      v-bind="{
        currentQuestion,
        attempt,
        isLabRunning,
        currentQuestionId,
        voucherId,
      }"
      @update-selection="updateSelectedAnswers"
      @handle-nav-loading="$emit('handle-nav-loading', $event)"
    />
  </div>
</template>

<script>
import CheckboxTick from '@/assets/images/certification/checkbox-tick.svg'
import AnswerTextbox from './AnswerTextbox.vue'
import { mapState } from 'vuex'

export default {
  name: 'Answers',
  components: {
    CheckboxTick: { ...CheckboxTick, name: 'CheckboxTick' },
    AnswerTextbox,
  },
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
    attempt: {
      type: Object,
      required: false,
    },
    isLabRunning: {
      type: Boolean,
      required: false,
      default: false,
    },
    voucherId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      currentSelection: [],
    }
  },
  computed: {
    ...mapState({
      currentCertification: state => state.certifications.currentCertification,
    }),
    answers() {
      const { answers } = this.currentQuestion
      return answers
    },
    answerTypeText() {
      return this.currentQuestion.type === 'text'
    },
  },
  watch: {
    currentQuestion(question, oldQuestion) {
      if (
        (oldQuestion.uuid || oldQuestion.question_id) !== this.currentQuestionId
      ) {
        this.currentSelection = []
        this.updateSelectedAnswers()
      }
    },
    currentSelection() {
      if (this.currentQuestion.answers) {
        this.currentQuestion.answers.map(a => {
          a.is_selected = this.currentSelection.includes(this.answerId(a))
        })
      } else {
        return [this.currentQuestion.question_id || this.currentQuestion.uuid]
      }
      this.$emit('current-selection-change', this.currentSelection)
    },
  },
  mounted() {
    this.updateSelectedAnswers()
  },
  methods: {
    answerContent(answer) {
      return answer.content || answer.answer_html
    },
    updateSelection(id) {
      if (!this.currentSelection.includes(id)) {
        this.currentSelection = [...this.currentSelection, id]
      } else {
        this.currentSelection = this.currentSelection.filter(
          selectionId => selectionId !== id
        )
      }
    },
    isSelected(answer) {
      return this.currentSelection.includes(answer.answer_id || answer.uuid)
    },
    updateSelectedAnswers() {
      if (!Array.isArray(this.currentSelection)) {
        this.currentSelection = [this.currentSelection]
      }
      let apiSelectedQuestion = []
      if (this.currentQuestion.answers) {
        apiSelectedQuestion = this.currentQuestion.answers.reduce(
          (acc, answer) => {
            if (answer.is_selected_by_user || answer.is_selected)
              acc.push(answer.answer_id || answer.uuid)
            return acc
          },
          []
        )
      } else {
        if (this.currentQuestion.user_answer) {
          apiSelectedQuestion = [this.currentQuestion.uuid]
        }
      }
      this.currentSelection = apiSelectedQuestion
    },
    answerId(answer) {
      return answer.answer_id || answer.uuid
    },
  },
}
</script>

<style lang="scss">
.answers {
  margin: 20px 0 0 0;
  color: #cecece;
  @include desktop {
    margin: 0;
    padding: 0 20px 15px 20px;
  }
  &__selection {
    display: flex;
    margin: 0 0 10px 0;
    border: 1px solid var(--tundora-gray);
    border-radius: 10px;
    cursor: pointer;
    &--selected {
      border-color: var(--silver-chalice-2);
      color: var(--white);
    }
  }
  &__select {
    background: none;
    border: none;
    margin: 0;
    position: relative;
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
  &__answer {
    font-size: 1rem;
    margin: 0 0 0 20px;
    font-family: var(--font-book);
    font-size: rem(16px);
    font-style: normal;
    font-weight: 400;
    line-height: rem(24px);
    pre,
    p {
      margin: 0;
      text-wrap: auto;
    }
  }
}
</style>
